var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "#FFF",
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.286 7.445a3.202 3.202 0 0 1 .41-1.53 3.17 3.17 0 0 1 1.091-1.14 3.238 3.238 0 0 0-1.109-.996 3.206 3.206 0 0 0-1.434-.39c-1.07-.114-2.108.646-2.653.646-.556 0-1.396-.635-2.3-.617-.585.02-1.155.191-1.654.498-.5.308-.912.74-1.196 1.256-1.233 2.153-.313 5.317.867 7.057.59.852 1.281 1.804 2.185 1.77.884-.037 1.214-.569 2.28-.569 1.058 0 1.367.569 2.29.547.948-.015 1.545-.855 2.115-1.716a7.074 7.074 0 0 0 .968-1.988 3.053 3.053 0 0 1-1.352-1.131 3.094 3.094 0 0 1-.508-1.697ZM8.546 2.244A3.151 3.151 0 0 0 9.256 0a3.15 3.15 0 0 0-2.044 1.067 2.987 2.987 0 0 0-.73 2.161 2.593 2.593 0 0 0 2.064-.984Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.c19c2da03ed63fb1d69bdcc368a83dfa.svg";
export { ForwardRef as ReactComponent };